var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'loader': true, 'loader--centered': _vm.centered }},[_c('div',{staticClass:"loader__dot"}),_vm._v(" "),_c('div',{staticClass:"loader__dot"}),_vm._v(" "),_c('div',{staticClass:"loader__dot"})])}
var staticRenderFns = []

export { render, staticRenderFns }